import React, { useState, useEffect, Suspense, useContext } from "react";
import { Paper, TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  TableCellDefault,
  Loading,
  InputCheckboxMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatablesServerSide, useDatatables } from "App/hooks";
import {
  addBulkTagihan,
  getByFilterTagihan,
  headCells,
  headCellsModal,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
} from "App/utils/helpers";

import FormFilterModalListTagihan from "./FormFilterModalListTagihan";
import { FreezeTable } from "components/organism";
import { LoadingBackdrop } from "components/atoms";
import { FormContext } from "../../context/FormContext";
import { RenderStatusPembelian } from "App/Component/layout/Penjualan/DaftarPenjualan/helpers";

export default function ModalListTagihan({
  setShowModal,
  setNewDataTagihan,
  asuransiID,
  asuransiNama,
  tanggal_awal,
  tanggal_akhir,
}) {
  const classes = STYLE_DEFAULT_MASTER();

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState({
    ...RESET_STATE_FORM_FILTER,
    asuransi_id: asuransiID,
    asuransi_name: asuransiNama,
    tanggal_awal: tanggal_awal,
    tanggal_akhir: tanggal_akhir,
  });

  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const { formData } = useContext(FormContext);

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterTagihan(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setData({
        total: res.total,
        pembayaran: res.pembayaran,
        sisa: res.sisa,
      });
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleBulkTagihan = async (row) => {
    const response = await addBulkTagihan(formData.rekap_tagihan_id, row);
    if (response.state) {
      await setNewDataTagihan();
      return {
        state: true,
        message: response.message,
      };
    } else {
      return {
        state: false,
        message: response.message,
      };
    }
  };

  return (
    <Modal width="70%" title="Daftar Tagihan" show={setShowModal}>
      <Suspense fallback={<LoadingBackdrop />}>
        <div className={classes.root}>
          <Paper
            className={classes.paper}
            style={{
              padding: "1rem",
            }}
          >
            <FormFilterModalListTagihan
              formFilter={formFilter}
              setFormFilter={setFormFilter}
              setNewData={setNewData}
              data={data}
              withExportButton
            />
            <Loading show={loading} />
            <div className="mt-1">
              <TableDaftarTagihan
                rows={rows}
                classes={classes}
                handleBulkTagihan={handleBulkTagihan}
                setShowModal={setShowModal}
              />
              <DatatablesFooterServerSide
                totalData={totalData}
                pagination={pagination}
                handleChangeLimit={handleChangeLimit}
                onPrevious={onPrevious}
                onNext={onNext}
                currentPage={pagination.page}
                handleClickPageNumber={handleClickPageNumber}
              />
            </div>
          </Paper>
        </div>
      </Suspense>
    </Modal>
  );
}

const TableDaftarTagihan = ({ rows, handleBulkTagihan, setShowModal }) => {
  const [loading, setLoading] = useState(false);
  const [rowsSelect, setRowsSelect] = useState([]);
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const handleClickSingleSelect = (row) => {
    const filter = rowsSelect.filter((item) => item.id_tagihan === row.id);
    if (filter.length > 0) {
      const filterExcept = rowsSelect.filter(
        (item) => item.id_tagihan !== row.id
      );
      setRowsSelect(filterExcept);
    } else {
      const selisih =
        parseFloat(
          isNull(row?.selisihLebihDitanggung) ? 0 : row?.selisihLebihDitanggung
        ) -
        parseFloat(
          isNull(row?.selisihKurangDitanggung)
            ? 0
            : row?.selisihKurangDitanggung
        );
      setRowsSelect([
        ...rowsSelect,
        {
          id_tagihan: row.id,
          rm_id: row?.rm_id,
          nama: row?.nama,
          rm_umur: row?.rm_umur,
          tgl_perawatan_awal: row?.tanggal_kunjungan,
          tgl_perawatan_akhir: row?.tanggal_pulang,
          penanggung: row?.guarantor_name,
          tanggal_tagihan: row?.tanggal_tagihan,
          guarantor_name: row?.guarantor_name,
          nama_asuransi: row?.nama_asuransi,
          nama_layanan: row?.nama_layanan,
          totaltagihan: row?.totalTagihan,
          total_dibayar: row?.total_bayar,
          sisa_tagihan:
            parseFloat(isNull(row?.totalTagihan) ? 0 : row?.totalTagihan) -
            parseFloat(isNull(row?.total_bayar) ? 0 : row?.total_bayar) +
            selisih  + row?.selisih_paket,
          no_asuransi: row?.no_asuransi,
          jenis_layanan_id: row?.jenis_layanan_id,
          status_pembayaran: row?.statusTagihan,
          selisih_paket: row?.selisih_paket,
          selisihTagihan: selisih,
        },
      ]);
    }
  };

  const handleClickAllSelect = () => {
    const _temp = [];
    rows.map((item) =>
      _temp.push({
        id_tagihan: item.id,
        rm_id: item?.rm_id,
        nama: item?.nama,
        rm_umur: item?.rm_umur,
        tgl_perawatan_awal: item?.tgl_perawatan_awal,
        tgl_perawatan_akhir: item?.tgl_perawatan_awal,
        penanggung: item?.guarantor_name,
        tanggal_tagihan: item?.tanggal_tagihan,
        guarantor_name: item?.guarantor_name,
        nama_asuransi: item?.nama_asuransi,
        nama_layanan: item?.nama_layanan,
        totaltagihan: item?.totalTagihan,
        total_dibayar: item?.total_bayar,
        sisa_tagihan:
          parseFloat(isNull(item?.totalTagihan) ? 0 : item?.totalTagihan) -
          parseFloat(isNull(item?.total_bayar) ? 0 : item?.total_bayar) +
          (parseFloat(
            isNull(item?.selisihLebihDitanggung)
              ? 0
              : item?.selisihLebihDitanggung
          ) -
            parseFloat(
              isNull(item?.selisihKurangDitanggung)
                ? 0
                : item?.selisihKurangDitanggung
            )  + item?.selisih_paket),
        no_asuransi: item?.no_asuransi,
        jenis_layanan_id: item?.jenis_layanan_id,
        status_pembayaran: item?.statusTagihan,
        selisih_paket: item?.selisih_paket,
        selisihTagihan: parseFloat(
          isNull(item?.selisihLebihDitanggung)
            ? 0
            : item?.selisihLebihDitanggung
        ) -
          parseFloat(
            isNull(item?.selisihKurangDitanggung)
              ? 0
              : item?.selisihKurangDitanggung
          ),
      })
    );
    setRowsSelect(_temp);
  };

  const checkAlready = (id) => {
    const filter = rowsSelect.filter((item) => item.id_tagihan === id);
    return filter.length > 0 ? true : false;
  };

  const handleClickReset = () => {
    setRowsSelect([]);
  };

  const handleClickSimpan = async () => {
    if (rowsSelect.length === 0) {
      defaultToastError("Harap pilih tagihan terlebih dahulu !");
    } else {
      setLoading(true);
      const response = await handleBulkTagihan(rowsSelect);
      if (response.state) {
        defaultToastSuccess(response.message);
        setShowModal(false);
        setLoading(false);
      } else {
        defaultToastError(response.message);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <FreezeTable
        headCells={headCellsModal}
        handleRequestSort={handleRequestSort}
        order={order}
        length={length}
        orderBy={orderBy}
      >
        {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
          const selisih =
            row?.selisihLebihDitanggung - row?.selisihKurangDitanggung;
          return (
            <TableRow
              onClick={(e) => handleClickSingleSelect(row)}
              hover
              tabIndex={-1}
              key={index}
              // style={{
              //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
              // }}
            >
              <TableCell align="center">{index + 1}</TableCell>
              <TableCell scope="row" width={"5%"} padding="none">
                <InputCheckboxMaster
                  name="status"
                  checked={checkAlready(row.id)}
                  id="status"
                  label=""
                  style={{ marginTop: "-10px", width: "31px", height: "19px" }}
                />
              </TableCell>
              <TableCell align="left" width="5%">
                {row?.id}
              </TableCell>
              <TableCell align="left" width="5%">
                {row?.IDGL}
              </TableCell>
              <TableCell align="left">
                {defaultDateDisplay(row?.tanggal_tagihan)}
              </TableCell>
              <TableCell align="left">{row?.nama}</TableCell>
              <TableCell align="left">{row?.rm_id}</TableCell>
              <TableCell align="left">{row?.no_sep}</TableCell>
              <TableCell align="left">
                {defaultDateDisplay(row?.tanggal_kunjungan)}
              </TableCell>
              <TableCell align="left">
                {defaultDateDisplay(row?.tanggal_pulang)}
              </TableCell>
              <TableCell align="left">{row?.nama_asuransi}</TableCell>
              <TableCell align="left">
                <RenderStatusPembelian status={row.statusTagihan} />
              </TableCell>
              <TableCell align="right">{formatNumber(selisih)}</TableCell>
              <TableCell align='right'>{formatNumber(row?.selisih_paket)}</TableCell>
              <TableCell align="left">
                {formatNumber(row?.totalTagihan)}
              </TableCell>
              <TableCell align="left">
                {formatNumber(row?.total_bayar)}
              </TableCell>

              <TableCell align="left">
              {formatNumber(row.totalTagihan - row.total_bayar + selisih + row?.selisih_paket)}
              </TableCell>

              <TableCellDefault row={row} />
            </TableRow>
          );
        })}
        {rows.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={headCells.length}>
              Tidak ada data
            </TableCell>
          </TableRow>
        )}
      </FreezeTable>
      <div
        className="mt-2"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <MasterButton
          color="danger"
          type="button"
          name="RESET"
          onClick={handleClickReset}
          size="xl"
          style={{
            padding: "0.5rem 1rem",
            textAlign: "center",
          }}
        />
        <MasterButton
          color="primary-cyan"
          type="button"
          name="SELECT PER PAGE"
          size="xl"
          onClick={handleClickAllSelect}
          style={{
            padding: "0.5rem 1rem",
            textAlign: "center",
          }}
        />

        <MasterButton
          color={loading ? "secondary" : "green"}
          type="button"
          name={loading ? "Loading.." : "SIMPAN"}
          disabled={loading}
          onClick={handleClickSimpan}
          size="xl"
          style={{
            padding: "0.5rem 1rem",
            textAlign: "center",
          }}
        />
      </div>
    </>
  );
};
